module.exports = __webpack_public_path__ + "static/cercazone_sudest3-30a6773abbd57a96ac8903aea58d7191.jpg";